module.exports = __webpack_public_path__ + "d150754c1b3397ce39bfc36770d2c2f5.png";